/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  SortLabelsRequestLabelsInner,
  SortLabelsRequestLabelsInnerFromJSON,
  SortLabelsRequestLabelsInnerFromJSONTyped,
  SortLabelsRequestLabelsInnerToJSON
} from './SortLabelsRequestLabelsInner'

/**
 *
 * @export
 * @interface SortLabelsRequest
 */
export interface SortLabelsRequest {
  /**
   *
   * @type {Array<SortLabelsRequestLabelsInner>}
   * @memberof SortLabelsRequest
   */
  labels?: Array<SortLabelsRequestLabelsInner>
}

export function SortLabelsRequestFromJSON(json: any): SortLabelsRequest {
  return SortLabelsRequestFromJSONTyped(json, false)
}

export function SortLabelsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SortLabelsRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    labels: !exists(json, 'labels')
      ? undefined
      : (json['labels'] as Array<any>).map(SortLabelsRequestLabelsInnerFromJSON)
  }
}

export function SortLabelsRequestToJSON(value?: SortLabelsRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    labels:
      value.labels === undefined ? undefined : (value.labels as Array<any>).map(SortLabelsRequestLabelsInnerToJSON)
  }
}
